<template>
  <div v-if="!completed">
    <div v-show="!validFields" class="required-info">
      Please fill out all required fields below
    </div>
    <div>
      <label>Email *</label>
      <input type="email" v-model="fields.email">
      <label>Phone *</label>
      <input type="tel" v-model="fields.phone">
      <label>First name *</label>
      <input type="text" v-model="fields.first_name">
      <label>Last name *</label>
      <input type="text" v-model="fields.last_name">
      <label>Address *</label>
      <input type="text" v-model="fields.invoice_address">
      <label>Zip *</label>
      <input type="text" v-model="fields.invoice_zip">
      <label>City *</label>
      <input type="text" v-model="fields.invoice_city">
      <label>Country *</label>
      <input type="text" v-model="fields.invoice_country">
      <label>Participants *</label>
      <input type="number" v-model="fields.participants">
      <label>Name of all Participants (Comma separated) *</label>
      <textarea v-model="fields.participants_name "></textarea>
      <!--input v-model="fields.work_address">
      <input v-model="fields.work_zip">
      <input v-model="fields.work_city">
      <input v-model="fields.work_country"-->
    </div>
    <div class="price">
      Total: <u>{{Number(json.amount * fields.participants).toFixed(2)}} {{json.items[0].currency}}</u>
    </div>
    <div v-show="validFields" class="pay">
      <h3>Choose payment method</h3>
      <label>Direct Payment</label>
      <PayPal
        :client="json.credentials"
        :amount="'' + Number(json.amount * fields.participants).toFixed(2)"
        :currency="json.currency"
        :env="json.mode"
        :items="[
          {
            name: json.items[0].name,
            description: json.items[0].description,
            quantity: fields.participants,
            price:  Number(json.items[0].price).toFixed(2),
            currency: json.items[0].currency
          }
        ]"
        @payment-authorized="authorizedPaypal($event)"
        @payment-completed="completedPaypal($event)"
        @payment-cancelled="cancelledPaypal($event)"
      >
      </PayPal>
      <label>Pay by Invoice</label>
      <button @click="completedInvoice">
        Proceed order
      </button>
    </div>
  </div>
  <div v-else class="thanks">
    <div v-if="method === 'paypal'">
      Thank you, your order has been received!<br><br>
      Order Receipt is sent to your email inbox!
    </div>
    <div v-else>
      Thank you, your order has been received!<br><br>
      Order Receipt is sent to your email inbox.
    </div>
    <button @click="completed=false, fields.participants = 1, fields.participants_name = ''">Add more participants</button>
  </div>
</template>

<script>
import fs from 'fs'
import path from 'path'
import moment from 'moment'
import PayPal from 'vue-paypal-checkout'
import axios from 'axios'
export default {
  components: { PayPal },
  props: ['json'],
  data () {
    return {
      completed: false,
      method: '',
      fields: {
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        invoice_address: '',
        invoice_zip: '',
        invoice_city: '',
        invoice_country: '',
        participants: 1,
        participants_name: ''
      }
    }
  },
  computed: {
    validFields () {
      if (this.fields.first_name.length < 2) return false
      if (this.fields.last_name.length < 2) return false
      if (this.fields.phone.length <= 6) return false
      if (this.fields.email.length <= 6 || this.fields.email.indexOf('@') === -1) return false
      if (this.fields.invoice_address.length <= 3) return false
      if (this.fields.invoice_zip.length <= 3) return false
      if (this.fields.invoice_city.length < 2) return false
      if (this.fields.invoice_country.length < 2) return false
      if (this.fields.participants < 1) return false
      // if (this.fields.participants_name.length < 1) return false
      return true
    },
  },
  methods: {
    authorizedPaypal (e) { console.log(e) },
    completedInvoice (e) {
      let inquiry_text = require('../templates/inquiry.txt.js').default
      let inquiry_html = require('../templates/inquiry.html.js').default

      inquiry_text = this.replaceInTemplate(inquiry_text)
      inquiry_html = this.replaceInTemplate(inquiry_html)

      // Send to seller first
      let body = new FormData()
      body.set('action', 'wera_email')
      body.set('body', JSON.stringify({
        from_name: this.json.seller_name,
        to: this.json.to_email,
        from: this.json.from_email,
        subject: 'Order Inquiry - Confirmation',
        text: inquiry_text,
        html: inquiry_html
      }))
      axios({
        url: this.json.email_ajax_url,
        method: 'post',
        data: body,
        config: { headers: { 'Content-Type': 'multipart/form-data' }}
      }).then(() => {
        // Then if success, send to customer
        body = new FormData()
        body.set('action', 'wera_email')
        body.set('body', JSON.stringify({
          from_name: this.json.seller_name,
          to: this.fields.email,
          from: this.json.from_email,
          subject: 'Order Inquiry - Confirmation',
          text: inquiry_text,
          html: inquiry_html
        }))
        axios({
          url: this.json.email_ajax_url,
          method: 'post',
          data: body,
          config: { headers: { 'Content-Type': 'multipart/form-data' }}
        }).then(() => {
          this.completed = true
        }).catch(e => {
          alert('Something went wrong. Please call uss.')
        })
      }).catch(e => {
        alert('Something went wrong. Please call uss.')
      })
    },
    completedPaypal (e) {
      let receipt_text = require('../templates/receipt.txt.js').default
      let receipt_html = require('../templates/receipt.html.js').default

      receipt_text = this.replaceInTemplate(receipt_text, e.id)
      receipt_html = this.replaceInTemplate(receipt_html, e.id)

      // Send to seller first
      let body = new FormData()
      body.set('action', 'wera_email')
      body.set('body', JSON.stringify({
        from_name: this.json.seller_name,
        to: this.json.to_email,
        from: this.json.from_email,
        subject: 'Order Completed - Receipt',
        text: receipt_text,
        html: receipt_html
      }))
      axios({
        url: this.json.email_ajax_url,
        method: 'post',
        data: body,
        config: { headers: { 'Content-Type': 'multipart/form-data' }}
      }).then(() => {
        // Then if success, send to customer
        body = new FormData()
        body.set('action', 'wera_email')
        body.set('body', JSON.stringify({
          from_name: this.json.seller_name,
          to: this.fields.email,
          from: this.json.from_email,
          subject: 'Order Completed - Receipt',
          text: receipt_text,
          html: receipt_html
        }))
        axios({
          url: this.json.email_ajax_url,
          method: 'post',
          data: body,
          config: { headers: { 'Content-Type': 'multipart/form-data' }}
        }).then(() => {
          this.completed = true
        }).catch(e => {
          alert('Something went wrong. Please call uss.')
        })
      }).catch(e => {
        alert('Something went wrong. Please call uss.')
      })
    },
    cancelledPaypal (e) {
      console.log(e)
    },
    replaceInTemplate (content, id = '') {
      // Seller
      content = content.replace(/\[\[seller_name\]\]/g, this.json.seller_name)
      content = content.replace(/\[\[seller_address\]\]/g, this.json.seller_address)
      content = content.replace(/\[\[seller_zip\]\]/g, this.json.seller_zip)
      content = content.replace(/\[\[seller_city\]\]/g, this.json.seller_city)
      content = content.replace(/\[\[seller_country\]\]/g, this.json.seller_country)
      content = content.replace(/\[\[seller_phone\]\]/g, this.json.seller_phone)
      
      // Billing
      content = content.replace(/\[\[billing_name\]\]/g, this.fields.first_name + ' ' + this.fields.last_name)
      content = content.replace(/\[\[billing_address\]\]/g, this.fields.invoice_address)
      content = content.replace(/\[\[billing_zip\]\]/g, this.fields.invoice_zip)
      content = content.replace(/\[\[billing_city\]\]/g, this.fields.invoice_city)
      content = content.replace(/\[\[billing_country\]\]/g, this.fields.invoice_country)
      content = content.replace(/\[\[billing_phone\]\]/g, this.fields.phone)

      // Generated
      content = content.replace(/\[\[billing_id\]\]/g, id)
      content = content.replace(/\[\[date\]\]/g, moment().format('MMM. DD. YYYY'))

      // Item
      content = content.replace(/\[\[name\]\]/g, this.json.items[0].name)
      content = content.replace(/\[\[quantity\]\]/g, this.fields.participants)
      content = content.replace(/\[\[participants\]\]/g, this.fields.participants_name)
      content = content.replace(/\[\[price\]\]/g, Number(this.json.items[0].price).toFixed(2))
      content = content.replace(/\[\[total\]\]/g, Number(this.json.amount * this.fields.participants).toFixed(2))
      content = content.replace(/\[\[thankyou\]\]/g, this.json.custom_text)
      content = content.replace(/\[\[thankyou_inquiry\]\]/g, this.json.custom_text_inquiry)
      content = content.replace(/\[\[prefix\]\]/g, this.json.prefix)
      content = content.replace(/\[\[suffix\]\]/g, this.json.suffix)

      return content
    }
  }
}
</script>

<style scoped>
label {
  width: 100%;
  display: block;
}
input, textarea {
  width: 100%;
}
.required-info {
  margin: 20px 0;
}
.price {
  margin: 20px 0;
}
.pay {
  margin: 20px 0;
}
.pay label {
  margin: 20px 0;
  font-weight: bold;
}
.thanks {
  margin: 20px 0;
}
</style>
